import React, { CSSProperties } from "react";

interface ProgressSlotsProps {
    totalSlots: number;
    filledSlots: number;
}

const CSS_CLASS_NAME = "c-progress-slots";

const ProgressSlots = ({ totalSlots, filledSlots }: ProgressSlotsProps) => {
    return (
        <ul
            className={CSS_CLASS_NAME}
            style={{ "--column-count": totalSlots } as CSSProperties}>
            {Array.from({ length: totalSlots }, (_, index) => index + 1).map(
                (slot) => (
                    <li
                        className={`${CSS_CLASS_NAME}__slot ${slot <= filledSlots ? "-filled" : "-unfilled"} ${filledSlots === totalSlots ? "-danger" : filledSlots === totalSlots - 1 ? "-warning" : "-safe"}`}>
                        <span className="sr-only">{slot}</span>
                    </li>
                )
            )}
        </ul>
    );
};

export default ProgressSlots;
